import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component } from '@angular/core';

import { CardLinkClickEvent, PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';

import { Card, ResponsiveService } from '@frk/eds-components';
import { Observable } from 'rxjs';
import { LinkService } from '@services/link.service';
import { TitleTheme } from '@frk/eds-components';

@Component({
  selector: 'ft-index-cards-section',
  templateUrl: './index-cards-section.component.html',
  styleUrls: ['./index-cards-section.component.scss'],
})
export class IndexCardsSectionComponent implements SectionComponent {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  /**
   * Section type
   */
  sectionType: string;

  /**
   * Is Mobile Device
   */
  isHandheld$: Observable<boolean>;

  theme: string;

  titleColorTheme: TitleTheme = 'basic';

  constructor(
    responsiveService: ResponsiveService,
    private ctaLinkService: LinkService
  ) {
    this.isHandheld$ = responsiveService.isHandheld$();
  }

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string
  ) {
    this.component = component;
    this.page = page;
    this.content = content;
    this.sectionType = sectionType;
    this.theme = theme;
    this.titleColorTheme =
      this.component?.getParameters()?.titleColor || 'basic';
  }

  setDownloadLocation(event: CardLinkClickEvent) {
    this.ctaLinkService.setUpdatedLinkData(event.downloadLocation);
  }
}
